// Tiny className combiner. Filters out falsy values so callers can write
// `cn(styles.root, isActive && styles.active, error && styles.invalid)`
// without sprinkling ternaries.

export type ClassValue = string | false | null | undefined;

export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(' ');
}
